import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PoiBoardSectionContext from '../components/pointsOfInterest/PoiBoardSectionContext';

// Components
import InboxHeader from './InboxHeader';
import InboxScrollableList from './InboxScrollableList';

// Constants
import { BoardSections } from '../../common/boards/boardConstants';

// Styles
import './Inbox.scss';

const Inbox = (props) => {
    const { inboxElementIds, setFocusOnInbox } = props;

    const inboxClassNames = classNames('Inbox', {
        empty: inboxElementIds.length === 0,
    });

    return (
        <div
            id="Inbox"
            className={inboxClassNames}
            onMouseDown={setFocusOnInbox}
            onDrop={setFocusOnInbox}
            onContextMenu={setFocusOnInbox}
        >
            <PoiBoardSectionContext.Provider value={BoardSections.INBOX}>
                <div className="inbox-header">
                    <InboxHeader {...props} />
                </div>
                <InboxScrollableList {...props} />
            </PoiBoardSectionContext.Provider>
        </div>
    );
};

Inbox.propTypes = {
    currentBoardId: PropTypes.string,
    onDrop: PropTypes.func,
    inboxElementIds: PropTypes.array,
    inboxElements: PropTypes.object,
    setFocusOnInbox: PropTypes.func,
    gridSize: PropTypes.number,

    isEditable: PropTypes.bool,
    selectionMarqueeActive: PropTypes.bool,
    setSelectionMarqueeActive: PropTypes.func,
    listElementProps: PropTypes.object,
};

export default Inbox;
